/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import PrimaryButton from './Button';
import OutlineButton from './OutlineButton';
import SecondaryButton from './SecondaryButton';
import SecondaryIconButton from './SecondaryIconButton';

type ButtonProps = {
  primary?: boolean;
  outline?: boolean;
  icon?: boolean;
  children?: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button: React.FC<ButtonProps> = forwardRef(
  ({ primary, outline, icon, children, ...rest }, ref) => {
    if (primary) {
      return (
        <PrimaryButton ref={ref} {...rest}>
          {children}
        </PrimaryButton>
      );
    }

    if (outline) {
      return (
        <OutlineButton ref={ref} {...rest}>
          {children}
        </OutlineButton>
      );
    }

    if (icon) {
      return (
        <SecondaryIconButton ref={ref} icon={icon} {...rest}>
          {children}
        </SecondaryIconButton>
      );
    }

    return (
      <SecondaryButton ref={ref} {...rest}>
        {children}
      </SecondaryButton>
    );
  }
);
